export function GoogleAnalyticsDirective(googleAnalyticsSetupService) {
    'ngInject';

    return {
        replace: false,
        link: function(scope, elem, attrs) {
            googleAnalyticsSetupService.setMetadata(attrs);
        }
    };
}
